import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const WrapDeleteDraft = styled('div')`
  border: 1px solid ${theme.colors.neutral.lighthover};
  padding: ${theme.spacing.sm} ${theme.spacing.xm};
  border-radius: ${theme.shapes.borderRadius.sm};
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.spacing.md};
`

export const MessageDeleteButton = styled('span')`
  font-weight: ${theme.typography.weight.lg};
  color: ${theme.colors.neutral.high};
  font-size: ${theme.typography.sizes.xs};
`
